import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { sidebarContent } from './Sidebar';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [sidebarContent],
});
